import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadSecrets } from './config/secrets';

// Completely hide WebSocket connection warnings (local + remote)
const originalConsoleWarn = console.warn;
console.warn = (...args: any[]) => {
  if (
    args.length &&
    typeof args[0] === 'string' &&
    args[0].includes('WebSocket connection to')
  ) {
    return; // ignore all WebSocket warnings
  }
  originalConsoleWarn.apply(console, args);
};

const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  if (
    args.length &&
    typeof args[0] === 'string' &&
    args[0].includes('WebSocket')
  ) {
    return; // ignore all WebSocket errors
  }
  originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

loadSecrets()
  .catch((err) => {
    console.error('Failed to load app config:', err);
  })
  .finally(() => {
    root.render(
      // <React.StrictMode>
        <App />
      // </React.StrictMode>
    );
    reportWebVitals();
  });
